// extracted by mini-css-extract-plugin
export default {"tablePagination":"table-pagination_tablePagination__ZnGa6","label":"table-pagination_label__o+Ubo","tablePagenationBlock":"table-pagination_tablePagenationBlock__1gfHa"};